export class ServiceManCurrentLocation {

    refNo: number;
    onDate: string;
    serviceManID: string;
    currentLongitude: string;
    currentLatitude: string;
    distanceCovered: string;
    weatherCondition: string;
    trafficDuration: string;
    fromLocCode: string;
    toLocCode: string;
    usedFor: string;
    usedForRefNo: string;
}

